import { type DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import { type Dispatch } from "redux"
import { fetchCurrencyExchange } from "~Shared/store/actions/currency/currencyActions"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"

export const subscribeToCurrencyExchange = (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType },
    } = data

    try {
        if (operationType === OperationTypeEnum.INSERT || operationType === OperationTypeEnum.UPDATE) {
            dispatch(fetchCurrencyExchange())
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Currency Exchange Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
